/**
 * NOTE: These methods are deprecated, please use src/js/components/editor/selectors instead.
 * Selectors are preferable to passing content down the set of components as this data changes
 * frequently causing a full editor tree rerender: https://www.pivotaltracker.com/story/show/168674593.
 */
import pathModule from 'path';
import { getValue, parentPath, appendPath } from '@truqc/content-path';
const extractCurrentPath = (path, contentPath) => contentPath ? path.substring(0, path.length - contentPath.length - 1) : path;
const convertToAbsolutePath = function convertToAbsolutePath(relativePath) {
  let currentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  if (relativePath === undefined) {
    return currentPath;
  }
  if (relativePath.startsWith('/') || !currentPath) {
    // Already an absolute path so just return
    return relativePath;
  }
  return pathModule.join(currentPath, relativePath);
};
const getValueAtRemotePath = (currentPath, remotePath, content) => {
  const parent = parentPath(currentPath);
  const fullPath = appendPath(parent, remotePath);
  return getValue(fullPath, content);
};
const convertToHex = value => value ? Math.floor(value * 255).toString(16) : '00';

/**
 * Convert an object with the following form:
 * {
 *   red: 1,
 *   green: 1,
 *   blue: 1
 * }
 * to a hex string.  Any values not supplied in the obeject
 * will default to '00' so if nothing is supplied then the result
 * will be '#000000'
 */
const convertToHexString = _ref => {
  let red = _ref.red,
    green = _ref.green,
    blue = _ref.blue;
  const redHex = convertToHex(red);
  const greenHex = convertToHex(green);
  const blueHex = convertToHex(blue);
  return "#".concat(redHex).concat(greenHex).concat(blueHex).toUpperCase();
};
export { extractCurrentPath, convertToAbsolutePath, convertToHexString, getValueAtRemotePath };